'use client'
import { FC, PropsWithChildren } from 'react'
import { LiveChatLoaderProvider } from 'react-live-chat-loader'

import env from '@/lib/env'

const LiveChatLoaderProviderWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <LiveChatLoaderProvider
      providerKey={env.INTERCOM_APP_ID}
      provider="intercom"
    >
      {children}
    </LiveChatLoaderProvider>
  )
}

export default LiveChatLoaderProviderWrapper
